(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name managePairing.service:ManagePairing
     *
     * @description
     *
     */
    angular
        .module('managePairing')
        .service('ManagePairing', ManagePairing);

    function ManagePairing(RemoteService, MessageService, ToolBarService, applicationConstants, CommonLogicService) {
        var self = this, deletePairingConfirm=false;
        self.pairingsList = [];
        self.noOfItems = 0;
        self.FLAGS = {
            ALL:'all',
            NEW: 'new',
            ADD_REMOVE:'add_remove'
        };

        self.BLOCK_TYPE = {
                EVENT:'event',
                FLIGHT:'flight',
                TRAINING:'training'
        };

        self.blockColorsForFlight = [];
        self.blockColorsForEvent = [];
        self.blockColorsForTraining = [];

        self.selectedPairingId = null;
        var view = "MANAGE_PAIRING";
        var selectedPairings = [], groupPairings = [];
        var viewButtonConfigs = {
            MANAGE_PAIRING_DAY:{
                btn:{
                    viewValue:'D',
                    viewTitle:'Day'
                },
                selected:false,
                disable:true,
                display:true
            },
            MANAGE_PAIRING_WEEK:{
                btn:{
                    viewValue:'W',
                    viewTitle:'Week'
                },
                selected:false,
                disable:true,
                display:true
            },
            MANAGE_PAIRING_2WEEK:{
                btn:{
                    viewValue:'2W',
                    viewTitle:'2Week'
                },
                selected:false,
                disable:true,
                display:true
            },
            MANAGE_PAIRING_MONTH:{
                btn:{
                    viewValue:'M',
                    viewTitle:'Month'
                },
                selected:false,
                disable:true,
                display:true
            }
        };

        self.deletePairingErrorType = {
            CREW_ASSIGNED_PATTERN:"crew_Assigned_pattern",
            EXPIRIES_EXISTS:"expiries_exists"
        };

        function PatternSearchRequest(){
            this.baseAirportCode = "";
            this.aircraftType = "";
            this.patternStartDate = "";
            this.patternEndDate ="";
            this.patternName = "";
            this.patternValidityType = "";
            this.patternModifyType = "";
            this.flightModifyType = "";
            this.flightNumber = "";
            this.airportCode ="";
            this.pageSize = "";
            this.startPosition="";
        }

        function DeletePatternRQ(){
            this.confirmToDeleteAssignedPattern = false;
            this.deletePatterns = [];
        }

        function DeletePatternDTO(){
            this.patternId = 0;
            this.patternVersion = 0;
            this.patternName = "";
            this.blockStartDateStr = "";
            this.blockStartTime = "";
        }

        function PairingSearchCriteria(){
            return {
                base:'',
                airCraftType:'',
                fromDate:'',
                toDate:'',
                flightNumber:'',
                airport:'',
                pairingName:'',
                isModifiedFlight:'All',
                isModifiedPairing:'B',
                pairingValidity:'B',
                acmiType:'',
                startPosition:1,
                pageSize:50
            };
        }

        self.getViewConfig = function(){
            return viewButtonConfigs;
        };

        self.getView = function(){
            return view;
        };

        self.getNoOfItems = function(){
            return self.noOfItems;
        };

        self.setNoOfItems = function(count){
            self.noOfItems = count;
        };

        self.getPairingsList = function(){
            return self.pairingsList;
        };

        self.initPairingList = function(){
            self.pairingsList = [];
        };

        self.setPairingsList = function(pairings){
            if (pairings.length>0){
                for(var i=0;i<pairings.length;i++){
                    self.pairingsList.push(adeptPairing(pairings[i]));
                }
            }
        };

        self.setSelectedPairings = function(pairing, flag){
            if (pairing==='null'){
                _.each(selectedPairings, function(obj){
                    obj.selectedFlag = false;
                });
                selectedPairings = [];
            }else{
                if(flag===self.FLAGS.ADD_REMOVE){
                    pairing.selectedFlag = true;
                    var index = _.indexOf(selectedPairings, pairing);
                    if (index>-1){
                        selectedPairings[index].selectedFlag = false;
                        selectedPairings.splice(index,1);
                    }else{
                        selectedPairings.push(pairing);
                    }

                }else if(flag===self.FLAGS.NEW){
                    _.each(selectedPairings, function(obj){
                        obj.selectedFlag = false;
                    });
                    pairing.selectedFlag = true;
                    selectedPairings[0] = pairing;
                }
                else if(flag===self.FLAGS.ALL){
                	selectedPairings = pairing;
                    _.each(selectedPairings, function(obj){
                        obj.selectedFlag = true;
                    });
                }
            }
        };

        self.getSelectedPairings = function(){
            return selectedPairings;
        };

        self.setColorToBlockData = function (blockList, successFn) {
        	angular.forEach(blockList, function(block){
        		var modelNo = !!block.aircraftModelNum1 ? block.aircraftModelNum1 : block.aircraftModelNum2;
        		angular.forEach(block.blockList, function(blocks){
        			angular.forEach(blocks.blockDetailList, function(blockDetail) {
        				if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.FLIGHT) {
        					var found = _.find(self.blockColorsForFlight, {trackingCode:modelNo});
        					if(!!found){
        						blockDetail.backgroundColor = found.backgroundColor;
        						blockDetail.fontColor = found.fontColor;
        					}
        				}

        				if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.EVENT &&
        						!(blockDetail.eventCode === "RST" || blockDetail.eventCode === "LAY")) {
        					var eventCode=blockDetail.eventCode;
        					var found = _.find(self.blockColorsForEvent, {trackingCode:eventCode});
        					if(!!found){
        						blockDetail.backgroundColor = found.backgroundColor;
        						blockDetail.fontColor = found.fontColor;
        					}
        				}

        				if(self.BLOCK_TYPE[blockDetail.blockDetailType] === self.BLOCK_TYPE.TRAINING) {
        					var trainingProgramCode = blockDetail.trainingProgramCode;
        					var found = _.find(self.blockColorsForTraining, {trackingCode:trainingProgramCode});
        					if(!!found){
        						blockDetail.backgroundColor = found.backgroundColor;
        						blockDetail.fontColor = found.fontColor;
        					}
        				}
        			});
        		});
        	});
        };

        self.searchPairings = function(searchParams, successFn, errorFn, isShowLoading){
            var sParams = new PatternSearchRequest();
            sParams.aircraftType = searchParams.airCraftType==''?null:searchParams.airCraftType;
            sParams.airportCode = searchParams.airport==''?null:searchParams.airport;
            sParams.baseAirportCode = searchParams.base==''?null:searchParams.base;
            sParams.flightModifyType = searchParams.isModifiedFlight==''?null:searchParams.isModifiedFlight;
            sParams.flightNumber = searchParams.flightNumber==''?null:searchParams.flightNumber;
            sParams.patternEndDate = searchParams.toDate==''?null:searchParams.toDate;
            sParams.patternModifyType = searchParams.isModifiedPairing==''?null:searchParams.isModifiedPairing;
            sParams.acmiType = searchParams.acmiType==''?null:searchParams.acmiType;
            sParams.patternName = $.trim(searchParams.pairingName)==''?null:$.trim(searchParams.pairingName);
            sParams.patternStartDate = searchParams.fromDate==''?null:searchParams.fromDate;
            sParams.patternValidityType = searchParams.pairingValidity==''?null:searchParams.pairingValidity;
            sParams.pageSize = searchParams.pageSize;
            sParams.startPosition = searchParams.startPosition;
            //Remote Call

            if (angular.isUndefined(isShowLoading)) {
                isShowLoading = true;
            }
            this.headerParam = {'show-loading': isShowLoading};
            RemoteService.searchPairing.call(this, sParams).then(
                function (response) {
                    if (response.success){
                        self.setNoOfItems(response.totalRecords);
                        self.setPairingsList(response.patternDTOs);
                        self.setColorToBlockData(response.patternDTOs);

                        //var tempGroup = self.getPairingsList();
                        //Un Comment this for add group overlapping
                        //var tempGroup = groupPairingsWithoutOverlapping();
                        successFn(response.patternDTOs);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getPairingById = function(pairingId, successFn, errorFn){
            RemoteService.getPatternById(pairingId).then(
                function (response) {
                    successFn(response.pattern);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getSelectedPatternEditable = function(pattern){
            var ret = true;

            // if (pattern.isAllBlocksLegal==='N' && !pattern.enableEditDeletedAndIllegalPattern){
            //     ret=false;
            // }
            // if(pattern.deletedFlightExist && !pattern.enableEditDeletedAndIllegalPattern){
            //     ret=false;
            // }
            return ret;
        };

        self.getSearchPairingsValidity = function () {
            var listLocalSearchWithin = [
                {
                    value: 'B',
                    name: "all",
                    text: "ALL",
                    selected: true
                },
                {
                    value: 'Y',
                    name: "valid",
                    text: "VALID",
                    selected: false
                },
                {
                    value: 'N',
                    name: "invalid",
                    text: "INVALID",
                    selected: false
                }
            ];
            return listLocalSearchWithin;
        };

        self.getCommonSelections = function () {
            var listLocalSelection = [
                {
                    value: 'B',
                    name: "all",
                    text: "ALL",
                    selected: true
                },
                {
                    value: 'Y',
                    name: "yes",
                    text: "YES",
                    selected: false
                },
                {
                    value: 'N',
                    name: "no",
                    text: "NO",
                    selected: false
                }
            ];
            return listLocalSelection;
        };

        self.setDeletePairingConfirm = function (flag) {
          deletePairingConfirm = flag;
        };

        self.getDeletePairingConfirm = function () {
            return deletePairingConfirm;
        }

        self.getFlightModifyList = function () {
            var listLocalSelection = [
                {
                    value: 'All',
                    name: "all ",
                    text: "All ",
                    selected: true
                },
                {
                  value: 'DUP',
                  name: "Duplicate ",
                  text: "Duplicate ",
                  selected: false
                },
                {
                    value: 'C',
                    name: "Cancelled ",
                    text: "Cancelled ",
                    selected: false
                },
                {
                    value: 'D',
                    name: "Deleted ",
                    text: "Deleted ",
                    selected: false
                },
                {
                    value: 'M',
                    name: "Modified ",
                    text: "Modified ",
                    selected: false
                },
                {
                    value: 'N',
                    name: "No ",
                    text: "No ",
                    selected: false
                }
            ];
            return listLocalSelection;
        };

        self.getCrewReqByPairingId = function(pairing, successFn, errorFn){
            RemoteService.loadCrewReqByPatternOnly(pairing.patternId).then(
                function (response) {
                    if (response.success){
                           successFn(adeptCrewRequirements(pairing, response.assignedCrewDTOs));
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.pairingSearchCriteria = function(){
            return new PairingSearchCriteria();
        };

        self.setSelectedPairingId = function(pairingId){
            self.selectedPairingId = pairingId;
        };

        self.getSelectedPairingId = function(){
            return self.selectedPairingId;
        };

        self.getLangReqByPairingId = function(pairing, successFn, errorFn){
            RemoteService.loadLanguageReqByPattern(pairing.patternId).then(
                function (response) {
                    if (response.success){
                        successFn(response.patternDTOs);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        self.getGenderReqByPairingId = function(pairing, successFn, errorFn){
          RemoteService.loadGenderReqByPattern(pairing.patternId).then(
            function (response) {
              if (response.success){
                successFn(response.patternGenderDTO);
              }
            },
            function (error) {
              errorFn(error.msg[0]);
            }
          );
        };

        self.setViewConfigByView = function(v){
            var btnConfigs = self.getViewConfig();
            angular.forEach(btnConfigs, function(btnObj,i){
                btnObj.selected = false;
                if(btnObj.btn.viewValue === v){
                    btnObj.selected = true;
                }
            });
            ToolBarService.setButtonConfigsToView(self.getView(), btnConfigs);
        };

        self.isDeletePairingErrorByType = function (errorType, arrErr) {
            var isError = false;
            if(arrErr.length>0){
                for(var i=0;i<arrErr.length;i++){
                    if(errorType === arrErr[i].errorType){
                        isError = true;
                        break;
                    }
                }
            }
            return isError;
        };

        self.checkCrewReqAvailability = function(pairingCrewReq){
            return checkAvailabilityOfCrewReqOnPairing(pairingCrewReq);
        };

        self.deletePairings = function(flg, successFn, errorFn){
            var selectedPatterns = self.getSelectedPairings();
            var getRealPairingFromDeleted = function(pairing){
                var send=null;
                angular.forEach(selectedPatterns, function(rPairng){
                    if(rPairng.patternId === pairing.patternId){
                        send = rPairng;
                    }
                });
                return send;
            };


            var deletePatternRq = new DeletePatternRQ();
            if (flg.toUpperCase()==='SELECTED'){
                deletePatternRq.deletePatterns[0] = adeptDeletePatterns(selectedPatterns[selectedPatterns.length-1]);
            }else{
                angular.forEach(selectedPatterns, function(pattern, index){
                    deletePatternRq.deletePatterns[index] = adeptDeletePatterns(pattern);
                });
            }
            deletePatternRq.confirmToDeleteAssignedPattern = self.getDeletePairingConfirm();

            RemoteService.deletePattern(deletePatternRq).then(
                function (response) {
                    if (response.success){
                        var deletedPairing = [];
                        angular.forEach(deletePatternRq.deletePatterns, function(dPairing){
                            deletedPairing.push(getRealPairingFromDeleted(dPairing));
                        });
                        response.deletedPairings = deletedPairing;
                    }
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        function adeptPairing(pairing){
            var adeptedPairing = pairing;
            adeptedPairing.totalDutyPeriod = CommonLogicService.getHoursByMinutes(adeptedPairing.totalDutyPeriod);
            return adeptedPairing;
        }

        function checkAvailabilityOfCrewReqOnPairing(pairingCrewReq) {
            var exist = true;
            for(var i=0;i<pairingCrewReq.length;i++){
                var crewReq = pairingCrewReq[i];
                if(crewReq.assignedName.length!==0){
                    exist = false;
                    for(var j=0;j<crewReq.assignedName.length;j++){
                        var assignedName = crewReq.assignedName[j];
                        if(assignedName.setInPattern){
                            exist=true;
                            break;
                        }
                    }
                    if(exist){
                        break;
                    }
                }
            }
            return exist;
        }

        function adeptCrewRequirements(pairing, crewReqResponse){
            var pairingReqList = pairing.requiredList;
            var getCrewNamesByTypes = function (type) {
                var crewName = [];
                angular.forEach(crewReqResponse, function(obj){
                    if(type===obj.crewTypeCode){
                        obj.disabled=true;
                        obj.setInPattern=true;
                        crewName.push(obj)
                    }
                });
                return crewName;
            };
            angular.forEach(pairingReqList, function(crewReq, key){
                crewReq.assignedName = getCrewNamesByTypes(crewReq.crewType);
                //crewReq.crewTypeDec = crewReq.crewType;
            });
            return pairingReqList;
        }

        function adeptDeletePatterns(pattern){
            var adPattern = new DeletePatternDTO();
            adPattern.patternId = pattern.patternId;
            adPattern.blockStartDateStr = pattern.startDate;
            adPattern.blockStartTime = pattern.startTime;
            adPattern.patternName = pattern.patternName;
            adPattern.patternVersion = pattern.version;
            return adPattern;
        }

        function groupPairingsWithoutOverlapping(){

            //assuming list comes sort by startDate & time
            var groupedPairings = [], groupIndex=0;

            var addNewGroup = function(obj, ind){
                    //create new
                    var tempGroup = {
                        groupIndex:ind,
                        maxLimit: moment(obj.endDate + ' ' + obj.endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT),
                        groupItems:[obj]
                    };
                groupedPairings.push(tempGroup);
            };

            var findGroupAndUpdate = function(obj, index){
                var temp = groupedPairings[index];
                temp.maxLimit = moment(obj.endDate + ' ' + obj.endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                temp.groupItems.push(obj);
            };

            var getPossibleGroupIndex = function(obj){
                var sendIndex = -1;
                angular.forEach(groupedPairings, function(group){
                    var currentDateTime = moment(obj.startDate + ' ' + obj.startTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                    if(currentDateTime.isAfter(group.maxLimit)){//now.isAfter
                        sendIndex = group.groupIndex;
                    }
                });
                return sendIndex;
            };

            angular.forEach(self.getPairingsList(), function(pairing){
                //check is there any existing group to put the current obj and update group index in the same function
                var possibleGroupIndex = getPossibleGroupIndex(pairing);
                if (possibleGroupIndex > -1){
                    pairing.groupIndex = possibleGroupIndex;
                    findGroupAndUpdate(pairing, possibleGroupIndex);
                }else{
                    pairing.groupIndex = groupIndex;
                    addNewGroup(pairing, groupIndex);
                    groupIndex++;
                }
            });
            return groupedPairings;
        }

        self.saveCrewComplement = function(params, successFn, errorFn){
            RemoteService.saveCrewComplement(params).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        self.syncCrew = function(params, successFn, errorFn){
            RemoteService.syncCrew(params).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        self.getCycleFromDate = function(date, successFn, errorFn){
            RemoteService.getCycleFromDate(date).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };

        function init() {
        	RemoteService.searchTrackingColors("aircraftModel").then(
					function (response) {
						if(response.success){
							self.blockColorsForFlight = response.colors;
						}
					},
					function (error) {
						MessageService.error(error.msg[0]);
					});
        	RemoteService.searchTrackingColors("event").then(
					function (response) {
						if(response.success){
							self.blockColorsForEvent = response.colors;
						}
					},
					function (error) {
						MessageService.error(error.msg[0]);
					});
        	RemoteService.searchTrackingColors("training").then(
        			function (response) {
        				if(response.success){
        					self.blockColorsForTraining = response.colors;
        				}
        			},
        			function (error) {
        				MessageService.error(error.msg[0]);
        			});
        }

        init();
    }
}());
